module.exports = __webpack_public_path__ + "static/media/card2.5032b597.svg";